import { i18n } from 'arm-common';
import * as React from 'react';
import * as agui from '../shared/v4';

class ConfirmModalDeleteV4 extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[ConfirmModalDeleteV4.jsx] ';
        this.state = {}
    }

    render() {
        console.log(this.componentName + "render");
        return (
            <div>
                < agui.ConfirmModalOkCancelV4 style={{}} id='close' show={this.props.show} className={'modal-dialog-centered'}>

                    <agui.ConfirmModalOkCancelV4.Header
                        className={this.props.classNameHeader}
                        classNameTitle={this.props.classNameTitle}
                        testoTitle={(this.props.testoTitle !== undefined && this.props.testoTitle !== null) ?
                            this.props.testoTitle : i18n('ARM_CORE_PRODUCT.SHARED.ELIMINA','Elimina') }
                        id={this.props.id}
                        onClose={this.props.onClose} />

                    <agui.ConfirmModalOkCancelV4.Body className={this.props.classNameBody}
                        classNameTesto={this.props.classNameTesto}
                        testoBody={(this.props.testoBody !== undefined && this.props.testoBody !== null) ?
                            this.props.testoBody : i18n ('ARM_CORE_PRODUCT.CONFERMI_LA.CANCELLAZIONE.ELEMENT','Confermi la cancellazione dell elemento selezionato?')} />

                    <agui.ConfirmModalOkCancelV4.Footer className={this.props.classNameFooter}
                        IdConfirm={this.props.IdConfirm}
                        classNameTestoButtonConfirm="btn btn-danger"
                        classNameIconConfirm="fas fa-trash-alt"
                        testoButtonConfirm= {i18n('ARM_CORE_PRODUCT.SHARED.ELIMINA','Elimina')}
                        IdCancel={this.props.IdCancel}
                        classNameTestoButtonCancel={this.props.classNameTestoButtonCancel}
                        classNameIconCancel={this.props.classNameIconCancel}
                        testoButtonCancel={this.props.testoButtonCancel}
                        confirmOnClick={this.props.deleteOnClick} onClose={this.props.onClose} />

                </agui.ConfirmModalOkCancelV4 >
            </div>
        );
    }
};

export default ConfirmModalDeleteV4;
